<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="角色用户查询">
        <span slot="label">{{ $t("tab.tab_role_user") }}</span>
        <SplitContainer2 style="height:100%" layout="horizontal" :split_setting="0.45">
          <template #table1>
            <div style="height:100%">
              <TableMain name="one table" ref="roleManageRef" :fields="fields" :title="table_title.title1"
                :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
                :show_date_picker="false" :show_toolbar="true" :table_height_adjust="-6" :show_filter="true"
                :show_check="true" :date_picker_label="date_picker_label" :query_button_label="query_lable"
                @on_query="on_query" @state_change="state_change" :show_toolbar_button="[1, 1, 0, 0, 1]"
                @current_changed="current_changed" @on_cell_button_click="on_cell_button_click"
                tableref="225f5db0d3374c74941c5ab71dc780cb">
                <template #toolbar="">
                  <el-button type="info" plain @click="createForm('new')" style="width: 55px"
                    class="ml-2 iconfont icon-add-new" size="mini">
                  </el-button>
                </template>
              </TableMain>
            </div>
          </template>
          <template #table2>
            <TableMain ref="roleUsersRef" :fields="role_users_fileds" :show_query_container="false"
              :show_toolbar="false" :title="table_title.title3" :date_picker_label="date_picker_label"
              :specialExport="true" @specialExport="exportRoleUsers" :table_height_adjust="10" :show_filter="false"
              tableref="9edd1dfada3c44a48f121ec9ec56c324">
              <template #specialExport>
                <el-dropdown-item command="specialExport" divided>{{ $t('common.userRoleExport') }}</el-dropdown-item>
              </template>
            </TableMain>
          </template>
        </SplitContainer2>
      </el-tab-pane>
      <el-tab-pane label="角色权限设置">
        <span slot="label">{{ $t("tab.tab_role_property") }}</span>
        <RolePrivilegeSet></RolePrivilegeSet>
      </el-tab-pane>
      <!-- <el-tab-pane label="绑定员工">
        <span slot="label">绑定员工</span>
        <CustTableSEIBindUser></CustTableSEIBindUser>
      </el-tab-pane> -->
    </el-tabs>

    <!-- 新增修改 -->
    <BaseModal ref="bvModal" :title="modal_title" @saveData="saveData" :size="'md'">
      <template #modal_content>
        <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="角色编码" prop="code">
            <el-input v-model="dataForm.code"></el-input>
          </el-form-item>
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="dataForm.name"></el-input>
          </el-form-item>
          <el-form-item label="角色说明" prop="description">
            <el-input type="textarea" v-model="dataForm.description"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import BaseModal from "../components/modals/baseModal"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as api from "../../shared/api"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import SplitContainer2 from "../components/container/SplitContainer2"
import * as RolePropertyManageController from "../../controllers/system/RolePropertyManageController"
import RolePrivilegeSet from "./RolePrivilegeSet"

export default {
  name: "RoleManage",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
    RolePrivilegeSet,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_role",
        title3: "table_role_user",
      },
      modal_title: this.$t("common.create_role"),
      fields: RoleManageController.fields,
      fields2: RoleManageController.fields2,
      role_users_fileds: RoleManageController.role_users_fileds,
      dataForm: _.cloneDeep(RoleManageController.dataForm),
      rules: RoleManageController.rules,
      methods: RoleManageController.methods,
      roleName: "",
      items: [],
      selectedItem: null,
      roleHasData: [],
      roleNewData: [],
      copyPrivilegesNum: 0,
      copyItems: [],
      tab_index: 0,
    }
  },
  created() {
    //this.GetPrivilige();
  },
  methods: {
    //同步
    async syncPrivileges() {
      if (this.$refs.roleManageRef.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的角色!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      this.msgModal("同步权限将清除角色自身含有的所有权限,确定此操作?").then(
        async (value) => {
          if (value) {
            let roleIds = []
            _.each(this.$refs.roleManageRef.GetSelectedItems(), (t) => {
              roleIds.push(t.id)
            })
            let _result = await RoleManageController.methods.syncRolePrivileges(
              roleIds,
              this.copyItems
            )
            if (_result && _result.length > 0) {
              this.msgToasts(this.$t("notify.action_successfully"), "success")
            }
          }
        }
      )
    },
    //追加
    async pastePrivileges() {
      if (this.$refs.roleManageRef.GetSelectedItems().length == 0) {
        this.msgToasts("请选择要粘贴的角色!", "info")
        return
      }
      if (this.copyItems.length == 0) {
        this.msgToasts("没有需要粘贴的项!", "info")
        return
      }
      let roleIds = []
      _.each(this.$refs.roleManageRef.GetSelectedItems(), (t) => {
        roleIds.push(t.id)
      })
      let _result = await RoleManageController.methods.pasteRolePrivileges(
        roleIds,
        this.copyItems
      )
      if (_result && _result.length > 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      }
    },
    //拷贝
    copyPrivileges() {
      this.copyItems = []
      if (!this.$refs.roleManageRef.GetCurrentItem()) {
        this.msgToasts("请选择要复制的角色!", "info")
        return
      }
      if (this.$refs.roleOwnPrivilegesRef.GetSelectedItems().length < 1) {
        this.copyPrivilegesNum = 0
        return
      }
      _.each(this.$refs.roleOwnPrivilegesRef.GetSelectedItems(), (t) => {
        this.copyItems.push(t.id)
      })
      this.copyPrivilegesNum = this.copyItems.length
      this.msgToasts("已拷贝角色权限!", "success")
    },
    //编辑
    async on_cell_button_click(data) {
      for (var i in this.dataForm) {
        if (_.isNull(data.item[i])) {
          this.dataForm[i] = ""
        } else {
          this.dataForm[i] = data.item[i]
        }
      }
      this.createForm("edit")
    },
    //保存角色权限
    async saveRoleOwnPrivileges() {
      let _this = this
      if (this.selectedItem == null) {
        this.msgToasts("请选择角色后再进行保存！", "warning")
        return
      }
      this.roleNewData = _.filter(
        _this.$refs.roleOwnPrivilegesRef.my_data,
        (d) => d._selected
      )

      let _b = await this.methods.AddORDeleteRoleOwnPrivileges(
        _this.selectedItem.id,
        _this.roleHasData,
        _this.roleNewData
      )
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
    //获取权限
    async GetPrivilige() {
      let _dt = await this.methods.GetPrivilege()
      this.$refs.roleOwnPrivilegesRef.SetData(_dt)
    },
    //#region 查询
    async on_query(set_data) {
      let _dt = await this.methods.GetRoleList()
      _dt = _.filter(_dt, { is_sys: false })
      set_data(_.orderBy(_dt, ["seq"], ["asc"]))
    },
    //#endregion

    //#region 保存
    ///初始化编辑界面
    createForm(code) {
      let title = ""
      switch (code) {
        case "new":
          title = "新增角色"
          this.dataForm = _.cloneDeep(RoleManageController.dataForm)
          break
        case "edit":
          title = "编辑角色"
          break
      }
      this.modal_title = title
      this.$refs.bvModal.show()
    },
    ///新增修改
    async saveData(cb) {
      let _this = this
      await this.$refs.dataForm.validate((valid) => {
        if (valid) {
          let _data = _.cloneDeep(_this.dataForm)
          ///保存数据
          _this.addRole(_data, cb)
        } else {
          cb(false)
          return false
        }
      })
    },
    // 新增
    async addRole(_data, cb) {
      let b = await this.methods.AddRole({
        id: _data.id,
        name: _data.name,
        code: _data.code,
        description: _data.description,
        is_valid: _data.is_valid,
      })
      cb(true, b.success)
      //如果未新增则在表格中新增一条数据
      //如过修改 则在表格中修改
      if (_data.id) {
        let index = _.findIndex(this.$refs.roleManageRef.my_data, {
          id: _data.id,
        })
        if (index > -1) {
          this.$set(
            this.$refs.roleManageRef.my_data[index],
            "name",
            _data.name
          )
          this.$set(
            this.$refs.roleManageRef.my_data[index],
            "description",
            _data.description
          )
        }
      } else {
        if (_.findIndex(this.$refs.roleManageRef.my_data, { id: b.id }) < 0) {
          this.$refs.roleManageRef.my_data.splice(0, 0, {
            id: b.id,
            name: _data.name,
            code: _data.code,
            description: _data.description,
            is_valid: true,
            is_sys: true,
            _current: false,
            _id: b.id,
            _selected: false,
          })
        }
      }
    },
    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      let _b = await this.methods.UpdateRole(data)
      if (_b) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
      } else {
        this.msgToasts("操作失败！", "error")
      }
      cb(data.state) //回调table操作
    },
    //#endregion

    current_changed(old, current) {
      //this.$emit("current_changed", old, current);
      if (!current) {
        return
      }
      this.selectedItem = current
      //获取角色对应的权限
      //this.getRolePrivileges(current.id);
      //获取角色对应的用户列表
      this.getRoleUsers(current.id)
    },
    //获取角色对应的权限
    async getRolePrivileges(id) {
      let _this = this
      let _dt = await this.methods.GetRoleOwnPrivilege(id)
      this.roleHasData = _dt
      _this.$refs.roleOwnPrivilegesRef.setSelect(_dt)
    },
    async getRoleUsers(id) {
      this.$refs.roleUsersRef.SetData([])
      let _dt = await this.methods.GetRoleUsers(id)
      if (_dt && _dt[0].length > 0) {
        this.$refs.roleUsersRef.SetData(_dt[0])
      }
    },

    //导出用户权限列表
    async exportUserPrivileges() {
      let loading = null
      let _this = this
      loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        background: "rgba(0, 0, 0, 0.7)",
      })
      let roleIds = []
      if (this.$refs.roleManageRef.my_data.length < 1) {
        loading.close()
        this.msgToasts(this.$t("notify.not_data"), "info")

        return
      }
      _.each(this.$refs.roleManageRef.my_data, (t) => {
        roleIds.push(t.id)
      })
      let selected_items = []
      let dataList =
        await RolePropertyManageController.methods.GetAllUserPrivileges(
          roleIds
        )

      _.each(dataList, (t) => {
        _.each(t.result.data.Result, (y) => {
          selected_items.push(y)
        })
      })


      if (selected_items.length < 1) {
        loading.close()
        _this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../shared/Export2Excel")
        const tHeader = []
        const filterVal = []
        let my_fields = RoleManageController.role_users_export_fileds
        for (var i in my_fields) {
          //过滤首列
          if (my_fields[i].key != "_selected") {
            tHeader.push(my_fields[i].label)
            filterVal.push(my_fields[i].key)
          }
        }
        const list = selected_items

        const data = list.map((v) => filterVal.map((j) => v[j]))
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        for (var index = 0; index < data.length; index++) {
          for (var j in data[index]) {
            if (data[index][j] == true && !numRe.test(data[index][j])) {
              data[index][j] = "√"
            }
            if (data[index][j] == false && !numRe.test(data[index][j])) {
              data[index][j] = ""
            }
          }
        }

        export_json_to_excel(tHeader, data, this.$t("table.table_role_property"), "", loading)
      })
    },
    //导出角色用户列表
    async exportRoleUsers() {
      let loading = null
      let _this = this
      loading = this.$loading({
        lock: true,
        text: this.$t("notify.loading"),
        background: "rgba(0, 0, 0, 0.7)",
      })

      let selected_items = []
      let dataList = await RoleManageController.methods.getRoleUsers()
      if (dataList && dataList.length > 0) {
        _.each(dataList[0], (t) => {
          selected_items.push(t)
        })
      } else {
        loading.close()
        this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }


      if (selected_items.length < 1) {
        loading.close()
        _this.msgToasts(this.$t("notify.not_selected_data"), "warning")
        return
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../shared/Export2Excel")
        const tHeader = []
        const filterVal = []
        let my_fields = RoleManageController._role_users_fileds
        for (var i in my_fields) {
          //过滤首列
          if (my_fields[i].key != "_selected") {
            tHeader.push(my_fields[i].label)
            filterVal.push(my_fields[i].key)
          }
        }
        const list = selected_items

        const data = list.map((v) => filterVal.map((j) => v[j]))
        var numReg = /^[0-9]*$/
        var numRe = new RegExp(numReg)
        for (var index = 0; index < data.length; index++) {
          for (var j in data[index]) {
            if (data[index][j] == true && !numRe.test(data[index][j])) {
              data[index][j] = "√"
            }
            if (data[index][j] == false && !numRe.test(data[index][j])) {
              data[index][j] = ""
            }
          }
        }

        export_json_to_excel(tHeader, data, "人员角色列表", "", loading)
      })
    },
  },
}
</script>
<style>
.role-table {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 1000px;
}
</style>
